import React from 'react'

import Toggle from 'lib/forms/toggle'
import PropTypes from 'prop-types'

const UsedStrings = ({ toggleAndUpdate, usedStrings, missingKeys }) => {
  return Object.keys(usedStrings).length === 0 ? (
    <div>
      Please first toggle the checkbox so we could count all the translation keys.
      <br />
      <br />
      <Toggle checked={window.i18nDevMode} onClick={toggleAndUpdate} />
    </div>
  ) : (
    <>
      <div className='upper-section'>
        <strong className='text-red'>
          NB! These are only all translations that were accessed <u>creating this version of the page</u> (&quot;
          {window.document.title}&quot;) and <u>not</u> necessarily all the possible different translations.
        </strong>
      </div>
      <div className='upper-section'>
        Clicking buttons, showing/hiding dialogs may reveal more translations that are not yet in the list.
      </div>
      <div className='upper-section'>Hint: Press CTRL+F (or ⌘+F) to find in this page.</div>
      <table className='i18n-table'>
        <tbody>
          {Object.keys(usedStrings).map(scope => (
            <tr key={scope} className={missingKeys[scope] ? 'missing' : ''}>
              <td>
                <a
                  href={`https://www.apprentus.com/admin/site_translations?path=${scope}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  {scope}
                </a>
              </td>
              <td>{usedStrings[scope]}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className='bottom-note'>
        Also note, this lists only the translations accessed by the React frontend. There might be more translations
        that were used in the backend. We will try to unify the systems soon.
      </div>
    </>
  )
}

UsedStrings.propTypes = {
  toggleAndUpdate: PropTypes.func,
  usedStrings: PropTypes.object,
  missingKeys: PropTypes.object
}

export default UsedStrings
